import { render } from "./payrollitems-model.vue?vue&type=template&id=4f61bfd2"
import script from "./payrollitems-model.vue?vue&type=script&lang=js"
export * from "./payrollitems-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__